(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["conversion-landing"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var root = document.currentScript ? document.currentScript : document;

    /* Reveal on scroll */
    var reveals = document.querySelectorAll('.cl-reveal');
    if ('IntersectionObserver' in window){
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if (e.isIntersecting){ e.target.classList.add('cl-in'); io.unobserve(e.target); }
        });
      }, { threshold:.14, rootMargin:'0px 0px -40px 0px' });
      reveals.forEach(function(el){ io.observe(el); });
    } else {
      reveals.forEach(function(el){ el.classList.add('cl-in'); });
    }

    /* Sticky buy bar: aparece tras pasar el hero */
    var sticky = document.querySelector('.cl-sticky');
    var hero = document.querySelector('.cl-hero');
    if (sticky && hero && 'IntersectionObserver' in window){
      var so = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if (e.isIntersecting){ sticky.classList.remove('cl-show'); sticky.setAttribute('aria-hidden','true'); }
          else { sticky.classList.add('cl-show'); sticky.setAttribute('aria-hidden','false'); }
        });
      }, { threshold:0 });
      so.observe(hero);
    }

    /* Galería: cambiar imagen principal del hero */
    var thumbs = document.querySelectorAll('.cl-thumb');
    thumbs.forEach(function(btn){
      btn.addEventListener('click', function(){
        var heroImg = document.querySelector('.cl-hero__img');
        if (heroImg && btn.dataset.full){ heroImg.src = btn.dataset.full; }
        thumbs.forEach(function(t){ t.classList.remove('is-active'); });
        btn.classList.add('is-active');
      });
    });

    /* FAQ tipo acordeón: cierra los demás al abrir uno */
    var faqItems = document.querySelectorAll('.cl-faq__item');
    faqItems.forEach(function(item){
      item.addEventListener('toggle', function(){
        if (item.open){
          faqItems.forEach(function(other){
            if (other !== item){ other.removeAttribute('open'); }
          });
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
